<template>
  <div class="alumni-select">
    <div class="content">
      <h1 class="title">请选择您需要填写的内容</h1>
      <p class="subtitle">四川师范大学校友会基础教育分会</p>
      <div class="cards">
        <div class="card card--shadow" @click="goUnit">
          <div class="card-icon personal-icon">
            <img src="@/assets/alumni/unit.png" alt="" class="card-img" />
          </div>
          <span class="card-text">校友单位信息表</span>
        </div>
        <div class="card card--shadow" @click="goPersonal">
          <div class="card-icon personal-icon">
            <img src="@/assets/alumni/personal.png" alt="" class="card-img" />
          </div>
          <span class="card-text">校友个人信息表</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUuid } from "@/util/util";
export default {
  name: "AlumniSelect",
  data() {
    return {};
  },
  created() {
    // this.showNative = true;
    // 查询缓存中是否存在uuid 如果不存在则生成一个 存在就不管
    const uuid = localStorage.getItem("alumni_uuid");
    if (!uuid) {
      localStorage.setItem("alumni_uuid", generateUuid());
    }
  },
  methods: {
    onClose() {
      if (this.$router && window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace("/");
      }
    },
    goUnit() {
      this.$router.push({ name: "AlumniUnitForm" });
    },
    goPersonal() {
      this.$router.push({ name: "AlumniPersonalForm" });
    },
  },
};
</script>

<style lang="scss" scoped>
.alumni-select {
  min-height: 100vh;
  background: #f9f9f9;
  padding: 12px 22px 32px;
  box-sizing: border-box;
}

.header-bar {
  padding: 8px 0 16px;
}

.close-icon {
  font-size: 22px;
  color: #333;
  cursor: pointer;
}

.content {
  padding-top: 8px;
}

.title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #001d3d;
  line-height: 1.35;
}

.subtitle {
  margin: 12px 0 0;
  font-size: 14px;
  color: #8e8e93;
  line-height: 1.4;
}

.cards {
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.card {
  display: flex;
  align-items: center;
  padding: 18px 16px;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active {
    opacity: 0.88;
  }
}

.card--border {
  border: 1px solid rgba(74, 116, 233, 0.45);
}

.card--shadow {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.card-icon {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  background: linear-gradient(145deg, #e8f0ff 0%, #f0f5ff 100%);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  overflow: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.icon-placeholder {
  font-size: 13px;
  color: #4a74e9;
  font-weight: 600;
}

.card-text {
  font-size: 18px;
  font-weight: 700;
  color: #242424;
}

.card-text--blue {
  color: #4a74e9;
}
</style>
